/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (!('serviceWorker' in navigator)) {
  console.log('Service Worker not supported')
} else {
  console.log('Service Worker supported')
}

if (!('PushManager' in window)) {
  console.log('Push Manager not supported')
} else {
  console.log('Push Manager supported')
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log('App is being served from cache by a service worker.')
    },

    registered () {
      console.log('Service worker has been registered.')
    },

    cached () {
      console.log('Content has been cached for offline use.')
    },

    updatefound () {
      console.log('New content is downloading.')

      if (window.__showUpdateDownloading) {
        window.__onUpdateConfirm = null // no reload yet, just info
        window.__showUpdateDownloading(
          'Update Available',
          'An update is being downloaded. Please wait...'
        )
      }
    },

    updated (registration) {
      console.log('New content is available.')

      if (registration.waiting) {
        // Handle manual activation
        if (window.__showUpdateDownloading) {
          window.__onUpdateConfirm = () => {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' })
          }

          window.__showUpdateDownloading(
            'Update Ready',
            'A new version is available. Click OK to reload.'
          )
        }

        // Once activated, force reload
        registration.waiting.addEventListener('statechange', (event) => {
          if (event.target.state === 'activated') {
            window.location.reload()
          }
        })
      }
    },

    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },

    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
